/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons401,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsDocumentRejectionReasons.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdAttachmentsDocumentRejectionReasons } from "../../clients/personDocumentsController/getApiV1PersonIdAttachmentsDocumentRejectionReasons.ts";

export const getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey = (
  id: GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams["id"],
) =>
  [
    {
      url: "/api/v1/person/:id/attachments/document-rejection-reasons",
      params: { id: id },
    },
  ] as const;

export type GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey =
  ReturnType<
    typeof getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey
  >;

export function getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryOptions(
  id: GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons401
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons500
    >,
    GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdAttachmentsDocumentRejectionReasons(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Lista os motivos de rejeição ativos para uso no fluxo de rejeição do anexo. **(Requer Authorization para autenticação)**
 * @summary Motivos de rejeição de documento (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/document-rejection-reasons}
 */
export function useGetApiV1PersonIdAttachmentsDocumentRejectionReasons<
  TData = GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
  TQueryData = GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey,
>(
  id: GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdAttachmentsDocumentRejectionReasons401
          | GetApiV1PersonIdAttachmentsDocumentRejectionReasons500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryOptions(
        id,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons401
      | GetApiV1PersonIdAttachmentsDocumentRejectionReasons500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
